module.exports = __webpack_public_path__ + "static/media/PrinceOfThePalisades_Bookcover.e3b388e7.jpg";